import * as React from 'react';
// @ts-ignore
import ReactModal from 'react-modal';
import {ChangeEvent} from "react";
// We can just import Slider or Range to reduce bundle size
export interface IInput {
    value: string|number,
    label: string,
    onChange: (...args:any[]) => void;
    message?: any;
}

export interface IProps {
    onClose: any;
    show: boolean;
    cancel: any;
    complete: any;
    completeButtonLabel?: string;
    inputs: Array<{
        value: string|number,
        label: string,
        onChange: (...args:any[]) => void;
        message?: any;
    }>;
    title: string;
    invalid?: boolean;
}

export interface IState {
    value: number | null;
    values: any;
}

export class VerticalModal extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            value: null,
            values: {}
        };
    }

    onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            value: Math.max(Math.min(Number(event.target.value), 5024), 0)
        })
    }

    handleComplete = () => {
        if (this.props.complete && (this.props.invalid === false)) {
            this.props.complete(this.state.values);
        }
    }

    render() {
        const buttonLabel = this.props.completeButtonLabel || 'Save';
        const {invalid} = this.props;
        return (
            <ReactModal
                /*
                  Boolean describing if the modal should be shown or not.
                */
                isOpen={this.props.show}
                ariaHideApp={false}
                onRequestClose={this.props.cancel}
                style={{
                    overlay: {
                        zIndex: 1000
                    },
                    content: {
                        maxWidth: '500px',
                        maxHeight: '200px',
                        margin: 'auto'
                    }
                }}
            >
            <div>
                <div style={{marginBottom: '10px'}}>{this.props.title}</div>
                {this.props.inputs.map(({value, label, onChange, message = null}, index) =>
                    <div key={`vert-modal-index-${index}`} className="modal-input">
                        <div> {label}</div>
                        <input value={value} onChange={onChange}/>
                        {message}
                    </div>
                )}

                <div className="buttonRow">
                    <div onClick={this.props.cancel}>
                        <button className="styledButton" style={{backgroundColor: '#f15a5a'}}>Cancel</button>
                    </div>
                    <div onClick={this.handleComplete}>
                        <button className={invalid ? 'button-disabled styledButton' : 'styledButton'}
                                style={{backgroundColor: invalid ? '#afafaf': '#646bf1'}}>{buttonLabel}</button>
                    </div>
                </div>

            </div>
            </ReactModal>
        );
    }
}
